import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke032aRequest, Sgke032aResponse, Sgke032aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
/**
 *
 * 入金消込登録
 * @export
 * @class UsedSgke012aService
 */
export class UsedSgke032aService {

  constructor(public service: Sgke032aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /** Sgke032aAPI実行 */
  public doSgke032a(request: Sgke032aRequest): Observable<Sgke032aResponse> {

    return this.service.ke32WSgke032aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE032A');
          return throwError(err.message);
        })
      );
  }
}
